/* ============================================================
   OVERHAUL BEHAVIOUR — session 26, Aug 1 2026
   Loaded after theme.js. One job only.
   ============================================================ */
(function () {
  'use strict';

  /* ----------------------------------------------------------
     The Coffee Club picker.
     Gaby, Jul 31: "what if someone wants 10 bags a month?"
     Everything is computed in front of the customer — total, per bag,
     per cup, and what the membership saves — so nobody has to work
     anything out, and nothing is hidden until checkout.
     ---------------------------------------------------------- */
  var box = document.querySelector('.k6-picker');
  if (!box) return;

  var qty   = box.querySelector('#k6-bags');
  var freq  = box.querySelector('#k6-freq');
  var minus = box.querySelector('.k6-minus');
  var plus  = box.querySelector('.k6-plus');
  var elTot = box.querySelector('#k6-total');
  var elPer = box.querySelector('#k6-per');
  var elSav = box.querySelector('#k6-save');
  var elNot = box.querySelector('#k6-note');
  var join  = box.querySelector('#k6-join');
  if (!qty || !elTot) return;

  var base = parseInt(box.dataset.base, 10) || 1799;   /* cents, one bag */
  var pct  = parseFloat(box.dataset.pct) || 0;
  var max  = parseInt(box.dataset.max, 10) || 12;
  var url  = box.dataset.url || '/pages/subscribe';

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function render() {
    var n = parseInt(qty.value, 10);
    if (isNaN(n) || n < 1) n = 1;
    if (n > max) n = max;
    qty.value = n;
    if (minus) minus.disabled = n <= 1;
    if (plus)  plus.disabled  = n >= max;

    var weeks  = parseInt(freq && freq.value, 10) || 4;
    var listed = base * n;
    var member = Math.round(listed * (1 - pct / 100));
    var perBag = Math.round(member / n);
    var perCup = Math.round(perBag / 28);           /* 1 lb is about 28 cups */
    var saved  = listed - member;

    elTot.textContent = money(member);
    elPer.textContent = n === 1
      ? 'every ' + weeks + ' weeks'
      : money(perBag) + ' a bag · every ' + weeks + ' weeks';
    elSav.textContent = saved > 0 ? 'You save ' + money(saved) + ' each delivery' : '';

    var cups = n * 28;
    elNot.textContent = n + (n === 1 ? ' bag' : ' bags') + ' — about ' + cups +
      ' cups, or ' + perCup + '¢ a cup. A cafe charges about $5.';

    if (join) join.href = url + '?bags=' + n + '&every=' + weeks;
  }

  if (minus) minus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) - 1; render(); });
  if (plus)  plus.addEventListener('click',  function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; render(); });
  qty.addEventListener('input',  render);
  qty.addEventListener('change', render);
  if (freq) freq.addEventListener('change', render);
  render();

  /* Add-to-bag is deliberately NOT handled here. theme.js already binds
     every .card__form on the page, including the compare table's, since
     they share the class. Binding it twice would add two bags a click. */
})();
